import { render } from "./UpdateProjectDetails.vue?vue&type=template&id=0499b6be&scoped=true"
import script from "./UpdateProjectDetails.vue?vue&type=script&lang=js"
export * from "./UpdateProjectDetails.vue?vue&type=script&lang=js"

import "./UpdateProjectDetails.vue?vue&type=style&index=0&id=0499b6be&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0499b6be"]])

export default __exports__